/**
 * Current user's own actively-suspended brand ids (`brands.id`, the integer PK — matches the `id`
 * field the brand-list API already returns), from `/affiliate-networks/suspended-brand-ids`. Unlike
 * `cjPidRegistry`'s account gating this has no permissive multi-value default: an anonymous or
 * unfetched viewer simply has zero suspensions, so `[]` is always correct, not a placeholder.
 */
let suspendedBrandIds: number[] = []

export const setSuspendedBrandIds = (ids: number[]): void => {
  suspendedBrandIds = Array.isArray(ids) ? ids : []
}

export const clearSuspendedBrandIds = (): void => {
  suspendedBrandIds = []
}

export const isBrandSuspended = (brand?: {
  id?: number | string | null
}): boolean => {
  if (!brand || brand.id == null) return false
  return suspendedBrandIds.includes(Number(brand.id))
}

/** Hide brands the current user is suspended from. Cosmetic only — the backend enforces on write. */
export const filterBrandsBySuspension = <
  T extends { id?: number | string | null }
>(
  brands: T[]
): T[] => {
  if (!Array.isArray(brands)) return brands
  if (!suspendedBrandIds.length) return brands
  return brands.filter(brand => !isBrandSuspended(brand))
}
